import React from 'react';
import * as MaterialUI from 'material-ui';
import { Field } from 'redux-form/immutable';

import * as validations from 'modules/forms/validations';
import { TextFieldF } from 'modules/forms/component';
import { listFindByMapId } from 'core/generalFunctions';

export default (props) => {
  const { reservable, hasReservas, precioBoletoId, penalizacionCancelacionCosto, penalizacionCancelacionPorcentaje, precios, precioBoleto } = props;

  let precioBoletoSeleccionado = precioBoleto || (precioBoletoId && precios && listFindByMapId(precios, precioBoletoId));
  if (precioBoletoSeleccionado && precioBoletoSeleccionado.get) precioBoletoSeleccionado = precioBoletoSeleccionado.get('precio');

  const precioPenalizacionPorPorcentaje = precioBoletoSeleccionado && penalizacionCancelacionPorcentaje && Math.round((penalizacionCancelacionPorcentaje * precioBoletoSeleccionado) / 100);
  console.log('hasReservas', hasReservas);
  if (!reservable && !hasReservas) return <div className="textCenter pt-20">Este viaje no admite reservas, por lo tanto no es posible aplicar penalizaciones por cancelación.</div>;
  return (
    <MaterialUI.Paper>
      <MaterialUI.Tabs>
        <MaterialUI.Tab label="Penalización por cancelación">
          <div className="p-lr-10">
            <p className="p-7 textSmall">Esta función sirve para cobrarle una penalización a los usuarios que cancelen una reserva bajos los terminos definidos</p>
            <Field
              name="penalizacionCancelacionMinutosPrevios"
              component={TextFieldF}
              inputProps={{
                fullWidth: true,
                hintText: 'Minutos previos al inicio del viaje',
                floatingLabelText: 'Minutos previos al inicio del viaje',
              }}
              validate={validations.number}
            />
            <Field
              name="penalizacionCancelacionCosto"
              component={TextFieldF}
              inputProps={{
                fullWidth: true,
                hintText: 'Costo fijo',
                floatingLabelText: 'Costo fijo',
                disabled: Boolean(penalizacionCancelacionPorcentaje),
              }}
              validate={validations.number}
            />
            {precioBoletoSeleccionado && precioPenalizacionPorPorcentaje !== false && (
              <Field
                name="penalizacionCancelacionPorcentaje"
                component={TextFieldF}
                inputProps={{
                  fullWidth: true,
                  hintText: 'Porcentual al precio del boleto',
                  floatingLabelText: precioPenalizacionPorPorcentaje ? 'Porcentual al precio del boleto ($' + precioPenalizacionPorPorcentaje + ')' : 'Porcentual al precio del boleto',
                  disabled: Boolean(penalizacionCancelacionCosto) || !precioBoletoSeleccionado,
                }}
                validate={validations.number}
              />
            )}
          </div>
        </MaterialUI.Tab>
      </MaterialUI.Tabs>
    </MaterialUI.Paper>
  );
};



// WEBPACK FOOTER //
// src/modules/rutinas/components/penalizacionCancelacion.js